import React from "react";

import {
  EquipmentContainer,
  ObstacleContainer,
  ObstacleItem,
  SubmitButton,
  ControlDockHeader,
  ControlDockContent,
  AreaGenerateContainer,
  AreaIcon,
  PathButtonContainer,
  AutovehicleSpecsInputContainer,
  WorkingModeContainer,
} from "../styled/potree/PotreeControl.styles";
import {
  useCustomAlertStore,
  usePathStore,
  usePointStore,
} from "../../Store/store";
import {
  AutovehicleSpecsStore,
  usePathModeStore,
  PotreeGenerateAreaStore,
  usePotreeStore,
  useLastAreaMeasurementStore,
} from "../../Store/PotreeStore";
import { useParams } from "react-router-dom";
import ColorSelectDropdown from "../CesiumUtil/ColorSelectDropdown";
import {
  ArrowsExapnd,
  ArrowsExapndVertical,
} from "../../assets/icons/WorkTypeIcons";
import { extractPathInfoAsJSON, downloadPathInfoAsJSON } from "./PathInfoModal";
import { useAreaMode } from "./Pathgenerate/hooks/useAreaMode";
import { useObstacle } from "./Pathgenerate/hooks/useObstacle";
import { usePathSave } from "./Pathgenerate/hooks/usePathSave";
import { usePathReset } from "./Pathgenerate/hooks/usePathReset";
import VehicleSpecsForm from "./Pathgenerate/VehicleSpecsForm";

export default function Pathgenerate({ isHidden, setIsHidden }) {
  const { SelectionGenerateMode, setSelectionGenerateMode, fullPathStore } =
    usePathModeStore();
  const { projectId } = useParams();
  const { showInfoAlert, showWarningAlert, showSuccessAlert } =
    useCustomAlertStore();
  const {
    selectedAutovehicleSpecs,
    setSelectedAutovehicleSpecs,
    updateUserSpecs,
    AutovehicleSpecs,
    interval,
    size,
    setInterval,
    setSize,
    resetUserSpecs,
    WorkMode,
    setWorkMode,
  } = AutovehicleSpecsStore();

  const {
    pathGenerateMode,
    setPathGenerateMode,
    pathEditMode,
    setPathEditMode,
    viewer,
    allObstaclePoints,
    selectedEquipmentId,
    resetEquipmentPath,
  } = usePathStore();

  const {
    areaModeIdList,
    selectedAreaType,
    setSelectedAreaType,
    openAddModal,
    deleteSelectedMode,
  } = useAreaMode();

  const {
    handleObstacleAdd,
    handleObstacleClick,
    handleRemoveObstacle,
    handleObstacleReset,
  } = useObstacle();

  const { handleSavePath, handleSaveAutoPath } = usePathSave();
  const { handlePathReset, handleHardReset, handleGradientCover, handleAreaRemove } =
    usePathReset();

  const {
    IsStartAreaGenerate,
    setIsStartAreaGenerate,
    pathMode,
    setPathMode,
    direction,
    setDirection,
    safetyMargin,
    setSafetyMargin,
    elevationRangeOffset,
    setElevationRangeOffset,
    isPathGenerated,
  } = PotreeGenerateAreaStore();

  const { editMode, setEditMode, potreeViewer } = usePotreeStore();
  const { lastAreaMeasurement } = useLastAreaMeasurementStore();
  const { selectedObstacleId } = usePointStore();
  // const [SelectionGenerateMode, setSelectionGenerateMode] = useState("auto");
  // const [WorkMode, setWorkMode] = useState("ridge");

  const handleStartAreaGenerate = () => {
    if (IsStartAreaGenerate) {
      setIsStartAreaGenerate(false);
      return;
    }
    setIsHidden(true);
    setIsStartAreaGenerate(true);
  };
  const handleEditPath = () => {
    setPathGenerateMode(false);
    setPathEditMode(!pathEditMode);
  };

  const handleGeneratePath = () => {
    setPathEditMode(false);
    setPathGenerateMode(!pathGenerateMode);
  };

  const handleAutoEquipmentChange = (e) => {
    // select를 바꾸면 글로벌 상태관리로 차량 스펙 id값을 업데이트한다.
    setSelectedAutovehicleSpecs(e.target.value);
    resetUserSpecs();
  };

  const currentSpecs =
    AutovehicleSpecs[selectedAutovehicleSpecs] || AutovehicleSpecs[3];

  const handleSpecInputChange = (field, value) => {
    if (selectedAutovehicleSpecs === "3") {
      updateUserSpecs(field, value);
    }
  };

  // 영역/경로 정보를 JSON으로 추출하는 핸들러
  const handleExtractPathInfo = () => {
    // 경로가 생성되지 않은 경우 예외 처리
    if (
      !fullPathStore ||
      !fullPathStore.features ||
      fullPathStore.features.length === 0
    ) {
      showInfoAlert("경로 추출 불가", "경로를 먼저 생성해주세요.");
      return;
    }

    try {
      // activeViewer 결정 (자동 모드면 potreeViewer, 수동 모드면 viewer)
      const activeViewer =
        SelectionGenerateMode === "auto" ? potreeViewer : viewer;

      // 차량 너비 가져오기
      const vehicleWidth =
        AutovehicleSpecs[selectedAutovehicleSpecs]?.width || 0;

      // 옵션 정보 구성
      const options = {
        pathMode,
        direction,
        workMode: WorkMode,
        interval,
        size,
      };

      // JSON 데이터 추출
      const jsonData = extractPathInfoAsJSON({
        activeViewer,
        fullPathStore,
        options,
        vehicleWidth,
        lastAreaMeasurement,
      });

      // 파일 다운로드
      downloadPathInfoAsJSON(jsonData);

      // 성공 알림
      showSuccessAlert(
        "데이터 추출 완료",
        "영역/경로 정보가 JSON 파일로 저장되었습니다.",
      );
    } catch (error) {
      console.error("데이터 추출 실패:", error);
      showInfoAlert(
        "데이터 추출 실패",
        "데이터를 추출하는 중 오류가 발생했습니다.",
      );
    }
  };

  return (
    <>
      <PathButtonContainer>
        <button
          onClick={() => setSelectionGenerateMode("auto")}
          className={SelectionGenerateMode === "auto" ? "active" : ""}
        >
          자동 생성
        </button>
        <button
          onClick={() => setSelectionGenerateMode("manual")}
          className={SelectionGenerateMode === "manual" ? "active" : ""}
        >
          수동 생성
        </button>
      </PathButtonContainer>
      {SelectionGenerateMode === "auto" ? (
        <div>
          <ControlDockHeader>
            <h2>자동 경로 생성</h2>
            <p>경로 생성 옵션을 설정할 수 있습니다.</p>
          </ControlDockHeader>
          <ControlDockContent>
            <VehicleSpecsForm
              selectedAutovehicleSpecs={selectedAutovehicleSpecs}
              AutovehicleSpecs={AutovehicleSpecs}
              currentSpecs={currentSpecs}
              onEquipmentChange={handleAutoEquipmentChange}
              onSpecInputChange={handleSpecInputChange}
            />

            <hr className="ControlDockContentDivider" />
            <PathButtonContainer>
              <button
                onClick={() => setWorkMode("ridge")}
                className={WorkMode === "ridge" ? "active" : ""}
              >
                두둑 성형
              </button>
              <button
                onClick={() => setWorkMode("seeding")}
                className={WorkMode === "seeding" ? "active" : ""}
              >
                파종
              </button>
            </PathButtonContainer>
            <WorkingModeContainer>
              {WorkMode === "seeding" ? (
                <AutovehicleSpecsInputContainer>
                  <div>
                    <label>파종 간격 (cm)</label>

                    <input
                      type="number"
                      placeholder="축간거리 (m)"
                      min="1"
                      step="1"
                      value={interval === "" ? "" : interval * 100}
                      onChange={(e) => {
                        const raw = e.target.value;

                        // 값 지울 수 있게 허용
                        if (raw === "") {
                          setInterval("");
                          return;
                        }

                        const cm = Number(raw);

                        if (cm <= 0) return; // 0과 음수 금지

                        // m 변환해서 저장
                        setInterval(cm / 100);
                      }}
                    />
                    <span>
                      간격은 0이하로 <br />
                      설정할 수 없습니다.
                    </span>
                  </div>
                  <div>
                    <label>작물 크기 (cm)</label>
                    <input
                      type="number"
                      placeholder="조향각 (°)"
                      min="1"
                      step="1"
                      value={size === "" ? "" : size * 100}
                      onChange={(e) => {
                        const raw = e.target.value;

                        // 값 지울 수 있게 허용
                        if (raw === "") {
                          setSize("");
                          return;
                        }

                        const cm = Number(raw);

                        if (cm <= 0) return; // 0과 음수 금지

                        // m 변환해서 저장
                        setSize(cm / 100);
                      }}
                    />
                  </div>
                </AutovehicleSpecsInputContainer>
              ) : (
                <p className="ControlDockContentText">
                  선택한 기계 스펙을 기준으로 <br />
                  두둑 성형 경로가 자동 생성됩니다.
                </p>
              )}
            </WorkingModeContainer>
            <hr className="ControlDockContentDivider" />
            <EquipmentContainer>
              <h2>턴 방식 선택</h2>
              <select
                name="turn-method"
                id="turn-method-select"
                onChange={(e) => setPathMode(e.target.value)}
                value={pathMode}
              >
                <option value="X-Turn">X-turn (X턴)</option>
                <option value="C-Turn">C-turn (C턴)</option>
              </select>
            </EquipmentContainer>
            <AutovehicleSpecsInputContainer>
              <div>
                <label>회전 여유(마진) (m)</label>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  placeholder="예: 0.3"
                  value={safetyMargin ?? 0}
                  onChange={(e) => {
                    const raw = e.target.value;
                    if (raw === "") {
                      setSafetyMargin(0);
                      return;
                    }
                    const v = Number(raw);
                    if (Number.isNaN(v) || v < 0) return;
                    setSafetyMargin(v);
                  }}
                />
                <span>
                  값을 줄이면 커버율은 올라가지만 <br />
                  회전 안전 여유가 부족할 수 있습니다.
                </span>
              </div>
            </AutovehicleSpecsInputContainer>
            <PathButtonContainer>
              <button
                onClick={() => setDirection("X")}
                className={direction === "X" ? "active" : ""}
              >
                {ArrowsExapnd} 방향
              </button>
              <button
                onClick={() => setDirection("Y")}
                className={direction === "Y" ? "active" : ""}
              >
                {ArrowsExapndVertical} 방향
              </button>
            </PathButtonContainer>
            <SubmitButton onClick={handleGradientCover}>
              고도 컬러맵 활성화
            </SubmitButton>
            <AutovehicleSpecsInputContainer>
              <div>
                <label>고도 범위 오프셋</label>
                <input
                  type="range"
                  min="0.5"
                  max="100"
                  step="0.5"
                  value={elevationRangeOffset}
                  onChange={(e) =>
                    setElevationRangeOffset(Number(e.target.value))
                  }
                  style={{ width: "100%" }}
                />
                <span>+{elevationRangeOffset.toFixed(1)}m</span>
              </div>
            </AutovehicleSpecsInputContainer>
            <hr className="ControlDockContentDivider" />
            <SubmitButton
              onClick={() => setEditMode(!editMode)}
              $switchState={editMode}
            >
              {editMode ? "수정 완료" : "경로 수정"}
            </SubmitButton>
            <SubmitButton
              onClick={handleStartAreaGenerate}
              $switchState={IsStartAreaGenerate}
              disabled={isPathGenerated}
              title={isPathGenerated ? "영역을 제거한 후 다시 지정할 수 있습니다." : ""}
            >
              {IsStartAreaGenerate ? "영역 지정 완료" : "영역 지정 시작"}
            </SubmitButton>

            {isPathGenerated && (
              <SubmitButton onClick={handleAreaRemove}>
                영역 제거
              </SubmitButton>
            )}

            <SubmitButton
              onClick={handleHardReset}
              title="페이지를 새로고침하여 포인트클라우드 로딩부터 다시 시작(전체 초기화)합니다."
            >
              포인트클라우드 재로딩
            </SubmitButton>

            <hr className="ControlDockContentDivider" />
            <SubmitButton
              onClick={handleExtractPathInfo}
              disabled={
                !fullPathStore ||
                !fullPathStore.features ||
                fullPathStore.features.length === 0
              }
              title={
                !fullPathStore ||
                !fullPathStore.features ||
                fullPathStore.features.length === 0
                  ? "경로를 먼저 생성해주세요."
                  : "현재 지정된 영역과 생성된 경로 정보를 JSON 파일로 추출합니다."
              }
            >
              영역/경로 추출
            </SubmitButton>
            {/* 경로 생성 버튼 */}
            <SubmitButton onClick={handleSaveAutoPath}>경로 저장</SubmitButton>
          </ControlDockContent>
        </div>
      ) : (
        <div>
          <ControlDockHeader>
            <h2>수동 경로 생성</h2>
            <p>경로 생성 옵션을 설정할 수 있습니다.</p>
          </ControlDockHeader>
          <ControlDockContent>
            <VehicleSpecsForm
              selectedAutovehicleSpecs={selectedAutovehicleSpecs}
              AutovehicleSpecs={AutovehicleSpecs}
              currentSpecs={currentSpecs}
              onEquipmentChange={handleAutoEquipmentChange}
              onSpecInputChange={handleSpecInputChange}
            />
            <hr className="ControlDockContentDivider" />
            <SubmitButton
              onClick={handleGeneratePath}
              $switchState={pathGenerateMode}
            >
              {pathGenerateMode ? "생성 완료" : "경로 생성"}
            </SubmitButton>
            <SubmitButton onClick={handleEditPath} $switchState={pathEditMode}>
              {pathEditMode ? "수정 완료" : "경로 수정"}
            </SubmitButton>

            <SubmitButton onClick={() => handlePathReset()}>
              선택 경로 초기화
            </SubmitButton>

            <hr className="ControlDockContentDivider" />

            {/* 장애물 지정 */}
            <ObstacleContainer>
              <h2>장애물 지정</h2>
              <AreaGenerateContainer>
                <div className="AreaGenerateSelectContainer">
                  <ColorSelectDropdown
                    options={areaModeIdList}
                    selectedValue={selectedAreaType}
                    onSelect={setSelectedAreaType}
                    placeholder="영역을 선택하세요"
                  />

                  <button
                    onClick={() => openAddModal()}
                    className="AreaGenerateSelectButton"
                  >
                    +
                  </button>
                  <button
                    onClick={() => deleteSelectedMode()}
                    className="AreaGenerateSelectButton"
                  >
                    -
                  </button>
                </div>

                <SubmitButton onClick={handleObstacleAdd}>
                  영역 추가
                </SubmitButton>
                <SubmitButton onClick={(e) => handleObstacleReset(e)}>
                  영역 초기화
                </SubmitButton>
                {allObstaclePoints.map((obstacle, index) => (
                  <ObstacleItem
                    key={index}
                    onClick={() => handleObstacleClick(obstacle.id)}
                    style={{
                      cursor: "pointer",
                      border:
                        obstacle.id === selectedObstacleId
                          ? "1px solid #a6ff00"
                          : "1px solid #333",
                    }}
                  >
                    <div className="ObstacleItemHeader">
                      <AreaIcon
                        $color={obstacle.color}
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-bounding-box-circles"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M0 2a2 2 0 0 1 3.937-.5h8.126A2 2 0 1 1 14.5 3.937v8.126a2 2 0 1 1-2.437 2.437H3.937A2 2 0 1 1 1.5 12.063V3.937A2 2 0 0 1 0 2m2.5 1.937v8.126c.703.18 1.256.734 1.437 1.437h8.126a2 2 0 0 1 1.437-1.437V3.937A2 2 0 0 1 12.063 2.5H3.937A2 2 0 0 1 2.5 3.937M14 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M2 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                      </AreaIcon>
                      <span className="ObstacleItemType">{obstacle.type}</span>
                      <button
                        className="ObstacleDeleteButton"
                        onClick={(e) => {
                          e.stopPropagation(); // 클릭 이벤트 전파 방지
                          handleRemoveObstacle(obstacle.id);
                        }}
                      >
                        삭제
                      </button>
                    </div>
                    <div className="ObstacleItemHeader">
                      <span>{obstacle.name}</span>
                      <span className="ObstacleItemIndex">
                        {index + 1}번 영역
                      </span>
                    </div>
                    <div className="ObstacleItemContent">
                      <p>{obstacle.description || "설명 없음"}</p>
                      <small>포인트: {obstacle.points.length}개</small>
                    </div>
                  </ObstacleItem>
                ))}
              </AreaGenerateContainer>
            </ObstacleContainer>
            <hr className="ControlDockContentDivider" />
            {/* 경로 생성 버튼 */}
            <SubmitButton onClick={handleSavePath}>경로 저장</SubmitButton>
          </ControlDockContent>
        </div>
      )}
    </>
  );
}
